<template>
    <div class="chat-wrapper">
        <Chats
            :roomList="room_list_data"
            @change-current-room="setCurrentRoom"
            @create-room="createRoom"
            :currentRoom="current_room"
        />
        <CurrentChat
            v-if="current_room.id !== 'Chat-is-destroy-now'"
            :currentRoom="current_room"
        />
        <RoomCreator
            v-if="isRoomCreatorOpen"
            @close-room-creator="isRoomCreatorOpen = false"
        ></RoomCreator>
    </div>
</template>

<script>
import Chats from './Chats';
import CurrentChat from './CurrentChat';
import RoomCreator from './RoomCreator';

import { mapActions, mapGetters } from 'vuex';

const actions = [
    'set_current_room',
];

const getters = [
    'isMobile',
    'user',
    'room_list_data',
    'current_room',
];

export default {
    name: 'Chat',
    data: ()=>({
        isRoomCreatorOpen: false,
    }),
    computed: {
        ...mapGetters(getters),
    },
    components: {
        CurrentChat,
        Chats,
        RoomCreator,
    },
    methods: {
        ...mapActions(actions),
        setCurrentRoom(room_obj) {
            this.set_current_room(room_obj);
        },
        createRoom(){
            if(this.isMobile) {
                document.querySelector(".mobile-header").style.zIndex = 0;
            }
            this.isRoomCreatorOpen = true;
        },
    },
    beforeDestroy() {
        this.setCurrentRoom({id: 'Chat-is-destroy-now'});
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    .chat-wrapper {
        position: relative;
        width: 100%;
        height: 33rem;
        background: white;
        display: flex;
        flex-direction: row;
        align-items: stretch;
        border-radius: 0.25rem;
        box-shadow: 0 0.3rem 0.5rem rgba(131, 134, 163, 0.12);
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {
        .chat-wrapper {
            height: 100%;
        }
    }
</style>
